export default __webpack_public_path__ + "static/media/docker.67daa957.png";